import { Title } from 'react-head'
import { BASE_PAGE_TITLE } from '@/constants/routes'

interface PageTitleProps {
  title: string | null
}

export const PageTitle = ({ title }: PageTitleProps) => {
  const fullTitle = title ? `${BASE_PAGE_TITLE} - ${title}` : BASE_PAGE_TITLE

  return <Title>{fullTitle}</Title>
}
